import { defineComponent, getCurrentInstance, useCssModule } from '@nuxtjs/composition-api';
import { ABOUT_CONTENT } from '~/pages/ratings/best-employers/data';
import { createHead, useAsyncRef } from '~/utils';
import { COPYRIGHT } from '~/constants';
export default defineComponent({
    name: 'About',
    layout: 'rating-best-employers',
    setup() {
        const css = useCssModule();
        const instance = getCurrentInstance();
        const title = useAsyncRef(instance, 'title');
        const COPYRIGHT_SPLIT = COPYRIGHT.split(' ');
        const year = COPYRIGHT_SPLIT[COPYRIGHT_SPLIT.length - 1];
        return {
            css,
            COPYRIGHT,
            ABOUT_CONTENT,
            title,
            year,
        };
    },
    async asyncData(context) {
        const { app, env, error, route } = context;
        try {
            const title = 'О рейтинге';
            const head = {
                canonical: env.HOST + route.path,
                title,
                url: env.HOST + route.path,
            };
            context.$page = app.$page = {
                title,
            };
            return {
                $page: context.$page,
                head,
                title,
            };
        }
        catch (e) {
            console.error(e);
            error({ statusCode: 404 });
        }
    },
    head() {
        return createHead(this.head);
    },
});
